// extracted by mini-css-extract-plugin
export default {"button":"Jq-z","reviewSort":"Kq-z"};